import { put, take, fork, all, select, call } from "redux-saga/effects";
import { CancellationServiceScope, CancellationServiceAction } from "./types";
import {
  enableScopeLoading,
  disableScopeLoading,
} from "../scope-loading/actions";
import * as Api from "../../service/api";
import { ScopeErrorAction } from "../scope-error/types";
import RouteNames from "../../routes/type";
import { navigateTo } from "../../helper";
import { clearCookie, getFolderName } from "./helpers";
import { cleanUpstate, updateCancellationState } from "./actions";
import { RootState } from "../root-reducer";
import axios from "axios";

function* createCancellationTicket() {
  while (true) {
    yield take(CancellationServiceAction.CREATE_CANCELLATION_TICKET);
    yield put(enableScopeLoading(CancellationServiceScope));
    try {
      const stateData = yield select(
        (state: RootState) => state.cancellationService
      );

      const documents = Object.entries(stateData.documents || {}).reduce(
        (acc: Record<string, any>, [key, val]: [string, any]) => {
          acc[key] = Array.isArray(val)
            ? val.map((u: string) => u.replace(/\.heic$/i, ".png"))
            : typeof val === "string"
            ? val.replace(/\.heic$/i, ".png")
            : val;
          return acc;
        },
        {}
      );

      const data = yield call(
        Api.deskTicket.cancellationServiceTicket,
        { ...stateData, documents }
      );
      if (data?.id) {
        clearCookie("cancellation_data");
        clearCookie("cancellation_foldername");
        yield put(cleanUpstate());
        yield navigateTo(
          `/${RouteNames.CANCELLATION_SERVICE}?step=5&ticket=${data?.ticketNumber}&id=${data?.ticketNumber}`
        );
      }
    } catch (error) {
      console.log("error:", error);
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: CancellationServiceScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(CancellationServiceScope));
    }
  }
}

function* uploadImageFlow() {
  while (true) {
    const { payload } = yield take(CancellationServiceAction.UPLOAD_IMAGE);
    const { fieldName, files } = payload;
    yield put(enableScopeLoading(CancellationServiceScope));
    try {
      const folderName = getFolderName();
      const uploadedFileUrls = yield all(
        files.map(function* (file) {
          const ext = file.name
            .substring(file.name.lastIndexOf(".") + 1)
            .toLowerCase();
          const fileType =
            ext === "heic" ? "image/heic" : file.type || "image/jpeg";
          const fileExtension = ext || fileType.split("/")[1];
          const { url } = yield Api.deskTicket.getPreSignedUrl({
            fileExtension,
            fileType,
            reqId: folderName,
          });
          yield axios.put(url, file, {
            headers: {
              "Content-Type": fileType,
            },
          });
          const data = new URL(url);
          data.search = "";
          return data.toString();
        })
      );
      yield put(
        updateCancellationState({
          documents: { [fieldName]: uploadedFileUrls },
        })
      );
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: CancellationServiceScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(CancellationServiceScope));
    }
  }
}

export default function* cancellationServiceSaga() {
  yield fork(createCancellationTicket);
  yield fork(uploadImageFlow);
}
